<avs-datagrid
  class="flex-1 min-h-0"
  (loadMore)="store.loadNextPage()"
  (sortChange)="onSortChange($event)"
  [class.fixed-scroll]="fixedScroll()"
  [columnOrder]="columnOrder()"
  [columns]="gridColumns()"
  [hasMore]="store.hasMore()"
  [isLoading]="store.isLoading()"
  [loadMoreThreshold]="loadMoreThreshold"
  [noDataBigPadding]="isNoDataBigSize()"
  [noDataResultContent]="criteriaStore.filtersApplied()"
  [noDataText]="noDataCopy()"
  [resizableColumns]="true"
  [rows]="rows()"
  [showLoadMoreSpinner]="true"
  [sort]="gridSort()"
  [stickyColumns]="stickyColumns()"
  [style.display]="gridDisplay()"
  [tableId]="gridTableId()"
  [trackBy]="trackById"
  [zoomControls]="true"
>
  <ng-template
    avsCell="index"
    let-index="index"
  >{{ index + 1 }}</ng-template>

  <ng-template
    avsCell="ticketNumber"
    let-row
  >
    <a
      class="underline test-ticket-number"
      [routerLink]="['/incidents', row.id]"
    >{{ row.ticketNumber }}</a>
  </ng-template>

  <ng-template
    avsCell="status"
    let-row
  >
    <div class="flex gap-1">
      <avs-incident-severity-icon [severity]="row.severity" />
      <span class="capitalize">{{ row.severity }}</span>
    </div>
  </ng-template>

  <ng-template
    avsCell="deviceId"
    let-row
  >
    <a
      class="underline"
      [routerLink]="row.deviceLink"
    >
      @if (row.isNetworkPort) {
        <div>{{ row.parentName }}</div>
      }
      <div>{{ row.deviceName }}</div>
    </a>
  </ng-template>

  <ng-template
    avsCell="deviceType"
    let-row
  >{{ row.deviceType }}</ng-template>

  <ng-template
    avsCell="building"
    let-row
  >
    <a
      class="underline"
      [routerLink]="['/dashboard', row.buildingId]"
    >{{ row.building }}</a>
  </ng-template>

  <ng-template
    avsCell="floor"
    let-row
  >
    <a
      class="underline"
      [routerLink]="['/dashboard', row.buildingId, row.floorId]"
    >{{ row.floor }}</a>
  </ng-template>

  <ng-template
    avsCell="room"
    let-row
  >
    <a
      class="underline"
      [routerLink]="['/dashboard', row.buildingId, row.floorId, row.roomId]"
    >{{ row.room }}</a>
  </ng-template>

  <ng-template
    avsCell="manufacturer"
    let-row
  >{{ row.manufacturer }}</ng-template>

  <ng-template
    avsCell="model"
    let-row
  >{{ row.model }}</ng-template>

  <ng-template
    avsCell="serialNumber"
    let-row
  >{{ row.serialNumber }}</ng-template>

  <ng-template
    avsCell="reported"
    let-row
  >{{ row.reported }}</ng-template>

  <ng-template
    avsCell="incidentRule"
    let-row
  >{{ row.incidentRule || '-' }}</ng-template>

  <ng-template
    avsCell="resolved"
    let-row
  >{{ row.resolved || '-' }}</ng-template>

  <ng-template
    avsCell="comments"
    let-row
  >
    <button
      type="button"
      class="icon-btn text-ui-gray-100 hover:text-ui-gray-dark"
      (click)="openNotesDialog(row)"
      aria-label="Incident notes"
    >
      <mat-icon [fontIcon]="row.notesIcon" />
    </button>
  </ng-template>
</avs-datagrid>

@if (showSpinner()) {
  <div class="flex justify-center items-center py-4">
    <mat-spinner diameter="36" />
  </div>
}
